import React from "react";
import SideNav from "../components/SideNav";
import UserDash from "../components/UserDash";
import SMEDash from "../components/SMEDash";
import IncubatorDash from "../components/IncubatorDash";
import EcosystemDash from "../components/EcosystemDash";
import FindALawyer from "../components/FindALawyer";
import Documents from "../components/Documents";
import Document from "../components/Document";
import LegalProducts from "../components/LegalProducts";
import LegalProduct from "../components/MyLandbot";
import FAQs from "../components/FAQs";
import FAQ from "../components/FAQ";
import { Row } from "react-bootstrap";
import { Route, Routes } from "react-router-dom";
import LandbotContainer from "../components/LandbotContainer";
import ProductIntro from "../components/ProductIntro";
import SearchResultsDash from "../components/SearchResultsDash";
import HealthCheckForm3 from "../components/HealthCheckForm3";
import UserValidator from "../components/UserValidator";
import Popi from "../components/Popi";
import { useSelector } from "react-redux";
import InvestmentReadiness from "../components/InvestmentReadiness";
import InvestmentDueDiligence from "../components/InvestmentDueDiligence";

import SearchBox from "../components/SearchBox";

import MobileDashNav from "../components/MobileDashNav";

import FeedbackQuestionLoT from "../lottie-files/FeedbackQuestion";

import FeedbackBot from "../components/FeedbackBot";
import GptExperi from "../components/GPTExperiment";
import LegalChecks from "../components/LegalChecks";
import BBBEE from "../components/BBBEE";
import MendableBot from "../components/MendableBot";

function Dashboard() {
  const { userInfo } = useSelector((state) => state.userLogin);
  const smeDetails = useSelector((state) => state.userSMEDetails);
  const { sme } = smeDetails;
  const tokens = sme.tokenCount;

  
//Landbot Feedback Widget
window.addEventListener('mouseover', initLandbot, { once: true });
window.addEventListener('touchstart', initLandbot, { once: true });
var myLandbot;
function initLandbot() {
  if (!myLandbot) {
    var s = document.createElement('script');s.type = 'text/javascript';s.async = true;
    s.addEventListener('load', function() {
      // eslint-disable-next-line
      var myLandbot = new Landbot.Livechat({
        configUrl: 'https://storage.googleapis.com/landbot.pro/v3/H-1417040-N5VP7XT8YOWTRG20/index.json',
      });
    });
    s.src = 'https://cdn.landbot.io/landbot-3/landbot-3.0.0.js';
    var x = document.getElementsByTagName('script')[0];
    x.parentNode.insertBefore(s, x);
  }
}


  return (
    <Row className="dashboard-container">
      <SearchBox classnameprop={"dash-search"} />
      <a className="ll-feedback" href="/dashboard/feedback">
        <FeedbackQuestionLoT aniName="feedback-lottie-dash" />
      </a>
      <SideNav tokens={tokens} />
      <Routes>
        <Route path="/validate" element={<UserValidator />} />
        <Route path="/sme-profile" element={<SMEDash userInfo={userInfo} />} />
        <Route path="/health-check" element={<HealthCheckForm3 />} />
        <Route path="/wieta-demo-index" element={<MendableBot />} />
        <Route
          path="/legal-checks"
          element={<LegalChecks userInfo={userInfo} />}
        />
        <Route path="/popi" element={<Popi />} />
        <Route path="/investment-readiness" element={<InvestmentReadiness />} />
        <Route path="/investment-due-diligence" element={<InvestmentDueDiligence />} />
        <Route path="/BBBEE" element={<BBBEE />} />
        {/* Chat GPT test page */}
        <Route
          path="/ai-assistant"
          element={<GptExperi userInfo={userInfo} />}
        />

        <Route path="/incubator-profile" element={<IncubatorDash />} />
        <Route path="/ecosystem-profile" element={<EcosystemDash />} />
        <Route path="/profile" element={<UserDash />} />
        <Route path="/find-a-lawyer" element={<FindALawyer />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/documents/:id" element={<Document />} />
        <Route path="/legal-products">
          <Route path="" element={<LegalProducts userInfo={userInfo} />} />
          <Route
            path=":category"
            element={<LegalProducts userInfo={userInfo} />}
          />
        </Route>
        <Route path="/feedback" element={<FeedbackBot />} />
        <Route
          path="/legal-products/intro/:id/:name/"
          element={<ProductIntro />}
        />
        <Route path="/legal-product/:id" element={<LegalProduct />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/faq/:id" element={<FAQ />} />
        <Route path="/bot/:historyid/:id" element={<LandbotContainer />} />
        <Route path="/search/:keyword" element={<SearchResultsDash />} />
      </Routes>
      <SearchBox classnameprop={"dash-search"} />
      <MobileDashNav />
    </Row>
  );
}

export default Dashboard;
